module.exports = __webpack_public_path__ + "static/key-supercloud-b5de29ccb0799859ed66497cb894e428.webp";